// extracted by mini-css-extract-plugin
export default {"mobileContainer":"Currency_mobileContainer__iAA4G","container":"Currency_container__HArvJ","table":"Currency_table__SBgwF"};